import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "../api/axios";

const DailySalesPage = () => {
  const navigate = useNavigate();
  const [sales, setSales] = useState([]);
  const [reportDate, setReportDate] = useState(
    new Date().toISOString().split("T")[0]
  );
  const [loading, setLoading] = useState(false);

  // Fetch daily sales
  const fetchSales = async () => {
    setLoading(true);
    try {
      const response = await axios.get(
        `reports/daily-sales?date=${reportDate}`
      );
      setSales(response.data.rows);
    } catch (error) {
      console.error(error);
      alert("Error fetching daily sales");
    }
    setLoading(false);
  };

  useEffect(() => {
    fetchSales();
  }, []);

  // Calculate totals for summary
  const summary = sales.reduce(
    (acc, row) => {
      acc.sup_amount += row.supplier_amount || 0;
      acc.sup_tax += row.supplier_tax || 0;
      acc.sup_total += row.supplier_total || 0;
      acc.cus_margin += row.customer_margin || 0;
      acc.sale_total += row.sale_total || 0;
      acc.amount_received += row.amount_received || 0;
      acc.outstanding += row.outstanding || 0;
      return acc;
    },
    {
      sup_amount: 0,
      sup_tax: 0,
      sup_total: 0,
      cus_margin: 0,
      sale_total: 0,
      amount_received: 0,
      outstanding: 0,
    }
  );

  return (
    <div className="container-fluid">
      <div className="d-flex justify-content-between align-items-center mt-3 mb-3">
        <h3 className="mb-0">Daily Sales Report - {reportDate}</h3>
        <button className="btn btn-secondary" onClick={() => navigate("/dashboard")}>
          Back to Dashboard
        </button>
      </div>

      <div className="mb-3">
        <input
          type="date"
          value={reportDate}
          onChange={(e) => setReportDate(e.target.value)}
        />
        <button className="btn btn-primary ms-2" onClick={fetchSales}>
          Load
        </button>
      </div>

      {loading ? (
        <p>Loading...</p>
      ) : (
        <>
          <table className="table table-bordered table-sm">
            <thead className="table-light">
              <tr>
                <th>REF #</th>
                <th>VALUE DATE</th>
                <th>CUSTOMER</th>
                <th>CUS. DUE DATE</th>
                <th>BILLING DETAILS</th>
                <th>SUPPLIER</th>
                <th>REF. STAFF</th>
                <th>LPO</th>
                <th>BILL NO</th>
                <th>SERVICE</th>
                <th>SERVICE DETAILS</th>
                <th>SUP. AMOUNT</th>
                <th>SUP. TAX</th>
                <th>SUP. COMM.RVD</th>
                <th>SUP. TOTAL</th>
                <th>CUS. MARGIN</th>
                <th>CUS. TRN FEE</th>
                <th>CUS. TAX</th>
                <th>CUS. DISCOUNT</th>
                <th>CUS. LOSS</th>
                <th>CUS. COM.PAY</th>
                <th>SALE TOTAL</th>
                <th>AMOUNT RECEIVED</th>
                <th>OUTSTANDING</th>
              </tr>
            </thead>
            <tbody>
              {sales.map((row, idx) => (
                <tr key={idx}>
                  <td>{row.reference_number}</td>
                  <td>{row.value_date}</td>
                  <td>{row.customer}</td>
                  <td>{row.customer_due_date || "-"}</td>
                  <td>{row.billing_details || "-"}</td>
                  <td>{row.supplier || "-"}</td>
                  <td>{row.reference_staff || "-"}</td>
                  <td>{row.lpo || "-"}</td>
                  <td>{row.bill_number || "-"}</td>
                  <td>{row.service}</td>
                  <td>{row.service_details || "-"}</td>
                  <td>{row.supplier_amount}</td>
                  <td>{row.supplier_tax}</td>
                  <td>{row.supplier_commission_received}</td>
                  <td>{row.supplier_total}</td>
                  <td>{row.customer_margin}</td>
                  <td>{row.customer_trm_fee}</td>
                  <td>{row.customer_tax}</td>
                  <td>{row.customer_discount}</td>
                  <td>{row.customer_loss}</td>
                  <td>{row.customer_company_pay}</td>
                  <td>{row.sale_total}</td>
                  <td>{row.amount_received}</td>
                  <td>{row.outstanding}</td>
                </tr>
              ))}
            </tbody>
            <tfoot>
              <tr className="table-light fw-bold">
                <td colSpan={11}>TOTAL</td>
                <td>{summary.sup_amount.toFixed(2)}</td>
                <td>{summary.sup_tax.toFixed(2)}</td>
                <td>-</td>
                <td>{summary.sup_total.toFixed(2)}</td>
                <td>{summary.cus_margin.toFixed(2)}</td>
                <td>-</td>
                <td>-</td>
                <td>-</td>
                <td>-</td>
                <td>{summary.sale_total.toFixed(2)}</td>
                <td>{summary.amount_received.toFixed(2)}</td>
                <td>{summary.outstanding.toFixed(2)}</td>
              </tr>
            </tfoot>
          </table>
        </>
      )}
    </div>
  );
};

export default DailySalesPage;
